import { useTexts } from '../hooks/useTexts'

import { form } from '../formState'

export function LimitedAccess() {
  const texts = useTexts()

  return (
    <form.Checkbox
      label={texts.labels.limitedAccess}
      name="limitedAccess"
      testId="limitedAccess"
      helperText={texts.helperText.limitedAccess}
    />
  )
}
